var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"v-tr",class:[_vm.rowClass, { 'selectable-row': _vm.selectable }],on:{"click":_vm.handleRowSelected}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }